import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
// import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  // Grid,
  // Typography,
  // IconButton,
  Slide,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import ModalTitleWithCloseIcon from '../modalTitleWithCloseIcon';
import styles from './style';
import { useSmall, useRouter } from '../../../hooks';
import { ContentDisplay, ContentProseDisplay } from '../../common';
import { updateTempState } from '../../../actions/temp';
// import { scrollStyles } from '../../../styles';

const useStyles = makeStyles(styles);
// const useScrollStyles = makeStyles(scrollStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DetailsModal = ({
  onClose,
  content,
  title,
  open = true,
  className,
  fullScreen = false,
  fullWidth = true,
  modalSize = 'sm',
  sx,
  // Added: Separate sx overrides for content and actions areas.
  // Previously both DialogContent and DialogActions shared the same `sx` prop.
  contentSx,
  actionsSx,
  proseMirrorContent,
  richTextContent,
  onBackClick,
  showBackButton,
  // Added: Allows callers to inject custom action buttons (React elements) into the modal footer
  actions,
  dialogTitle,
  // Added: Optionally hides the default Close button when custom actions provide their own
  hideCloseAction = false,
  // Added: Shows a horizontal divider below the modal title via ModalTitleWithCloseIcon
  showTitleDivider = false,
  dontReloadOnClose = false,
}) => {
  const isSmall = useSmall();
  const router = useRouter();
  const dispatch = useDispatch();
  const classes = useStyles({ isSmall, modalSize });
  // const scrollClasses = useScrollStyles();
  // , scrollClasses.scrollbar
  // const dispatch = useDispatch();

  const lastBrowserUrl = useSelector((state) => state.temp.lastBrowserUrl);

  const neutralizeBack = (callback) => {
    if (lastBrowserUrl !== window.location.href) {
      window.history.pushState(null, '', window.location.href);
      dispatch(
        updateTempState.updateTempStateAction({ lastBrowserUrl: window.location.href }),
      );
    }
    window.onpopstate = () => {
      // window.history.pushState(null, '', window.location.href);
      callback();
    };
  };

  const revivalBack = () => {
    window.onpopstate = undefined;
    window.history.go(-1);
  };

  const handleClose = () => {
    onClose();
  };

  const handleBeforeClose = () => {
    handleClose();
    if (!dontReloadOnClose) {
      revivalBack();
    }
  };

  useEffect(() => {
    if (open) {
      neutralizeBack(handleClose);
    }
  }, [open]);

  // Added: Merge base sx with section-specific overrides for independent content/actions styling
  const contentStyles = { ...(sx || {}), ...(contentSx || {}) };
  const actionStyles = { ...(sx || {}), ...(actionsSx || {}) };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      // onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      scroll="body"
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      classes={{ paper: classnames(classes.dialog, className) }}
      maxWidth={modalSize}
    >
      <ModalTitleWithCloseIcon
        className={classes.headerTitle}
        classes={{ root: classes.dialogActions }}
        title={title}
        onClose={handleBeforeClose}
        sx={sx}
        showBackButton={showBackButton}
        onBackClick={onBackClick}
        // Added: Pass showTitleDivider to render a Divider under the modal title
        showDivider={showTitleDivider}
      />

      {/* Changed: sx replaced with contentStyles to support separate content styling */}
      <DialogContent className={classnames(classes.root)} sx={contentStyles}>
        {richTextContent && richTextContent?.length >= 10 && (
          <ContentDisplay sx={{ py: 1, px: 3 }} content={richTextContent} />
        )}
        {proseMirrorContent && proseMirrorContent?.length >= 10 && (
          <ContentProseDisplay sx={{ py: 1, px: 3 }} content={proseMirrorContent} />
        )}
        {content}
      </DialogContent>
      <DialogActions
        classes={{
          root: classnames(classes.dialogActions, { [classes.pinToBottom]: fullScreen }),
        }}
        // Changed: sx replaced with actionStyles to support separate actions styling
        sx={actionStyles}
      >
        {/* Added: Render custom action buttons passed by callers */}
        {actions}
        {/* Added: Conditionally render Close button based on hideCloseAction prop */}
        {!hideCloseAction && (
          <Button
            sx={{ width: 'auto' }}
            onClick={handleBeforeClose}
            className={classes.secondaryButton}
            align="right"
          >
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DetailsModal;

/*
      <DialogTitle id="alert-dialog-title">
        <Grid container direction="row" alignItems="center" justifyContent="center">
          <Grid item xs={10} align="left">
            <Typography variant="h6">{title}</Typography>
          </Grid>
          <Grid item xs={2} align="right">
            {onClose ? (
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={onClose}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Grid>
        </Grid>
      </DialogTitle>
      */
